document.addEventListener("DOMContentLoaded", function () {
    console.log("Belt Size Wizard script initialized.");

    const belts = [
        { size: "00 (Youth Medium)", length: 79.5 },
        { size: "0 (Youth Large)", length: 84.5 },
        { size: "1 (XX-Small)", length: 87.4 },
        { size: "2 (X-Small)", length: 91.3 },
        { size: "3 (Small)", length: 96.9 },
        { size: "4 (Medium)", length: 104.7 },
        { size: "5 (Large)", length: 112.6 },
        { size: "6 (X-Large)", length: 122.8 },
        { size: "7 (XX-Large)", length: 130.7 },
        { size: "8 (XXX-Large)", length: 133.9 }
    ];

    const knotLength = 40 / 2.54; // Knot length in inches
    const tieOffset = 8 / 2.54; // Tie offset in inches

    function resetProgressBar() {
        const progress = document.getElementById("progress");
        if (!progress) {
            console.error("Progress bar element not found.");
            return;
        }
        progress.style.width = "0";
        progress.style.animation = "none";
        setTimeout(() => {
            progress.style.animation = "loadProgress 1.5s linear forwards";
        }, 10);
        console.log("Progress bar reset.");
    }

    function startCalculation() {
        console.log("Calculation started.");
        const progressBarContainer = document.getElementById("progressBarContainer");
        const resultDiv = document.getElementById("result");
        const calculatingText = document.getElementById("calculatingText");

        if (!progressBarContainer || !resultDiv || !calculatingText) {
            console.error("One or more required elements (progress bar, result, calculating text) are missing.");
            return;
        }

        resetProgressBar();
        progressBarContainer.style.display = "block";
        calculatingText.style.display = "block";
        resultDiv.style.opacity = "0";
        resultDiv.style.display = "none";

        setTimeout(() => {
            calculateBeltSize();
        }, 1500);
    }

    function calculateBeltSize() {
        const waist = parseFloat(document.getElementById("waist").value);
        const hangDown = parseFloat(document.getElementById("hangDown").value);

        console.log("Inputs received - Waist:", waist, "Hang Down:", hangDown);

        if (!waist || !hangDown) {
            alert("Please fill out both fields.");
            return;
        }

        const closestBelt = belts.reduce((best, belt) => {
            const actualHangDown = (belt.length - 2 * waist - knotLength - tieOffset) / 2;
            const diff = Math.abs(actualHangDown - hangDown);

            console.log(`Checking belt size ${belt.size} with actual hang down: ${actualHangDown.toFixed(1)} inches.`);

            if (best === null || diff < best.diff) {
                return { belt, diff, actualHangDown };
            }
            return best;
        }, null);

        const progressBarContainer = document.getElementById("progressBarContainer");
        const resultDiv = document.getElementById("result");
        const statusMessage = document.getElementById("statusMessage");
        const recommendationText = document.getElementById("recommendation");
        const actualHangDownText = document.getElementById("actualHangDown");
        const lightbulb = document.querySelector(".Belt-Size-Wizard-lightbulb");
        const calculatingText = document.getElementById("calculatingText");

        if (!progressBarContainer || !resultDiv || !statusMessage || !recommendationText || !actualHangDownText || !lightbulb || !calculatingText) {
            console.error("One or more required result elements are missing.");
            return;
        }

        if (closestBelt) {
            console.log("Closest belt found:", closestBelt);

            statusMessage.style.display = "block";
            recommendationText.style.display = "block";
            actualHangDownText.style.display = "block";
            lightbulb.style.display = "block";

            recommendationText.textContent = `The recommended size for your inputs is: ${closestBelt.belt.size}, with a length of ${closestBelt.belt.length} inches.`;
            actualHangDownText.textContent = `With this belt, the hang-down length would likely be approximately ${closestBelt.actualHangDown.toFixed(1)} inches per side.`;
        } else {
            console.log("No suitable belt size found.");
            statusMessage.style.display = "block";
            statusMessage.textContent = "No suitable belt size found. Please try adjusting your inputs.";
            recommendationText.style.display = "none";
            actualHangDownText.style.display = "none";
            lightbulb.style.display = "none";
        }

        progressBarContainer.style.display = "none";
        calculatingText.style.display = "none";

        resultDiv.style.display = "block";
        setTimeout(() => {
            resultDiv.style.opacity = "1";
        }, 10);
    }

    const calculateButton = document.querySelector(".Belt-Size-Wizard-button");
    if (calculateButton) {
        calculateButton.addEventListener("click", startCalculation);
        console.log("Calculate button initialized.");
    } else {
        console.error("Calculate button not found.");
    }
});